import React, {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem} from "@mui/material";
import CustomFormControl from "../../../../../alert-center/Dropdown/CustomFormControl";

const CampaignImportDialog = ({ open, onClose, campaignList, onConfirm }) => {
    const [selectedCampaign, setSelectedCampaign] = useState("");
    const handleImportClick = () => {
        if (selectedCampaign) {
            onConfirm(selectedCampaign);
        }
    };

    return <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>Select a Campaign to Import</DialogTitle>
        <DialogContent>
            <CustomFormControl
                value={selectedCampaign}
                onChange={(e) => setSelectedCampaign(e.target.value)}
                displayEmpty
                minWidth="60%"
                MenuProps={{
                    PaperProps: {
                        sx: { maxHeight: 300 }
                    }
                }}
            >
                <MenuItem value="" disabled>
                    <span style={{
                        fontSize: "12px",
                        color: "#bab7b7"
                    }}>Select Campaign</span>
                </MenuItem>
                {campaignList.map((campaign) => {
                    return (
                        <MenuItem key={campaign.campaign_id} value={campaign.campaign_id}>
                            <span style={{
                                fontSize: "12px",
                                color: "#373F41"
                            }}>{campaign.campaign_settings?.campaign_name || campaign.campaign_name || `Campaign ID : ${campaign.campaign_id}`}</span>
                        </MenuItem>
                    );
                })}
            </CustomFormControl>
        </DialogContent>
        <DialogActions>
            <Button
                onClick={onClose}
                variant="outlined"
                size="small"
                sx={{
                    textTransform: "none",
                    fontSize: "12px",
                    borderColor: "#ccc",
                    color: "#666",
                    borderRadius: "20px",
                    "&:hover": { borderColor: "#999", backgroundColor: "#fafafa" },
                }}
            >
                Cancel
            </Button>
            <Button
                onClick={handleImportClick}
                variant="contained"
                size="small"
                disabled={!selectedCampaign}
                sx={{
                    textTransform: "none",
                    fontSize: "12px",
                    backgroundColor: "#61D5A9",
                    color: "#fff",
                    borderRadius: "20px",
                    "&:hover": { backgroundColor: "#12794F" },
                    "&:disabled": { backgroundColor: "#c8e6d8", color: "#fff" },
                }}
            >
                Import
            </Button>
        </DialogActions>
    </Dialog>;
};

export default CampaignImportDialog;